
import Nl2br from '~/mixins/nl2br.js'
import ChevronIcon from '~/assets/icons/chevron.svg'
import MinusIcon from '~/assets/icons/minus.svg'
import PlusIcon from '~/assets/icons/plus.svg'

export default {
  name: 'AccordionItem',
  components: {
    ChevronIcon,
    MinusIcon,
    PlusIcon
  },
  mixins: [Nl2br],
  props: {
    item: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    id: {
      type: Number,
      required: true,
      default: null
    },
    groupId: {
      type: Number,
      required: true,
      default: null
    },
    textColor: {
      type: String,
      required: false,
      default: '#383838'
    },
    itemPadding: {
      type: String,
      required: false,
      default: '--small'
    },
    titleSize: {
      type: String,
      required: false,
      default: 'h-large'
    },
    titleType: {
      type: String,
      required: false,
      default: 'h3'
    },
    isTechnicalFeatureAccordionItem: {
      type: Boolean,
      required: false,
      default: false
    },
    iconBackgroundColor: {
      type: String,
      required: false,
      default: ''
    }
  },
  data () {
    return {
      isActive: false,
    }
  },
  computed: {
    sanatiseText () {
      return this.item.content.html.replace('/site', '')
    },
    cssVars () {
      return {
        '--icon-bg-color': this.iconBackgroundColor,
        '--with-icon-grid-columns-base': this.isTechnicalFeatureAccordionItem ? '0.7fr 2.7fr 0.1fr' : '0.4fr 3fr 0.1fr',
        '--with-icon-grid-columns-medium-mobile': this.isTechnicalFeatureAccordionItem ? '0.4fr 3fr 0.1fr' : '0.3fr 3fr 0.1fr',
        '--with-icon-grid-columns-tablet': this.isTechnicalFeatureAccordionItem ? '0.3fr 3fr 0.1fr' : '0.2fr 2.5fr 0.1fr',
        '--with-icon-grid-columns-tablet-landscape': this.isTechnicalFeatureAccordionItem ? '0.4fr 3fr 0.1fr' : '0.4fr 2.5fr 0.1fr',
        '--with-icon-grid-columns-desktop': this.isTechnicalFeatureAccordionItem ? '0.4fr 3fr 0.1fr' : '0.3fr 2.5fr 0.1fr',
        '--with-icon-grid-columns-desktop-large': this.isTechnicalFeatureAccordionItem ? '0.3fr 3fr 0.1fr' : '0.2fr 2.5fr 0.1fr',
        '--title-font-weight-technical-accordion': this.isTechnicalFeatureAccordionItem ? '600' : ''
      }
    },
    itemId () {
      return `item-${this.groupId}-${this.id}`
    }
  },
  methods: {
    toggle () {
      this.isActive = !this.isActive
    },
    startTransition (el) {
      el.style.height = el.scrollHeight + 'px'
    },

    endTransition (el) {
      el.style.height = ''
    }
  },

}
